/* eslint-disable */
import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import React, { useState } from 'react';
import {Modal, Divider, Input, Text} from '@nextui-org/react';
import AddIcon from "@mui/icons-material/Add";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// @mui
import {
  Card,
  Stack,
  Button,
  Popover,
  MenuItem,
  Container,
  Typography,
  Grid
} from '@mui/material';
import { useFormik } from "formik";
import * as yup from "yup";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

// components
// sections
// mock

// ----------------------------------------------------------------------


// ----------------------------------------------------------------------



function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}
const validationSchema = yup.object({
    nama: yup.string("Enter your password").required("Nama Tidak Boleh Kosong"),
    jabatan: yup
      .string("Enter your password")
      .required("Jabatan Tidak Boleh Kosong"),
    tanggal_gaji: yup
      .string("Enter your password")
      .required("Tanggal gaji Tidak Boleh Kosong"),
  });

export default function UserPage(props) {
  const [open, setOpen] = useState(null);

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('name');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(5);
  const { data } = props;

  const [status, setStatus] = React.useState("");
  const [rule, setRule] = React.useState([]);
  const [rulesname, setRulesname] = React.useState("");
  const [description, setDescription] = React.useState("");
  const [severitylevel, setSeveritylevel] = React.useState("");
  const [channel, setChannel] = React.useState("");
  const [limit, setLimit] = React.useState("");
  const [action, setAction] = React.useState([]);
  const [actionsorted, setActionsorted] = React.useState([]);

  const capitalizeFirst = (str) => {
    const str1 = str.split("_").join(" ");
    return str1.charAt(0).toUpperCase() + str1.slice(1);
  };
  const formik = useFormik({
    initialValues: {
      nama: data && data.Nama,
      jabatan: (data && data.jabatan) || "",
      tanggal_gaji: (data && data.Tanggal_gaji) || "",
      gaji_pokok: (data && data.gaji_pokok) || "",
      pulsa: (data && data.pulsa) || "",
      tunjangan_hari_raya: (data && data.tunjangan_hari_raya) || "",
      tunjangan_kehadiran: (data && data.tunjangan_kehadiran) || "",
      tunjangan_luar_kota: (data && data.tunjangan_luar_kota) || "",
      dedikasi: (data && data.dedikasi) || "",
      bpjs_ketenagakerjaan: (data && data.bpjs_ketenagakerjaan) || "",
      setoran_bpjs_kesehatan: (data && data.setoran_bpjs_kesehatan) || "",
      setoran_bpjs_ketenagakerjaan:
        (data && data.setoran_bpjs_ketenagakerjaan) || "",
      potongan_kehadiran: (data && data.potongan_kehadiran) || "",
      kasbon_gaji: (data && data.kasbon_gaji) || "",
      gaji_bersih: (data && data.gaji_bersih) || "",
      jumlah_penerimaan: (data && data.Jumlah_penerimaan) || "",
      jumlah_potongan: (data && data.Jumlah_potongan) || "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {},
  });

  function save() {
    const newDate = new Date();
    const date = newDate.getDate();
    const month = newDate.getMonth() + 1;
    const year = newDate.getFullYear();
    const separator = "-";

 const item = {
      rulesname,
      description,
      severitylevel,
      channel,
      limit,
      status,
      created_at: `${year}${separator}${
        month < 10 ? `0${month}` : `${month}`
      }${separator}${date}`,
      created_by: "system admin",
      data: rule,
      action: action,
      actionsorted: actionsorted,
    };
}
  const TextfieldCustom2 = ({
    id = "",
    size = "",
    titles = "",
    placeholder = "",
    dropdown = [],
    label = "",
    multiline = false,
    value = "",
    changer,
  }) => {
    return (
      <Grid item md={size}>
        <Grid container direction={"column"} spacing={0}>
          <Grid item>
            <Typography variant="subtitle2">{titles}</Typography>
          </Grid>
          <Grid item>
            {dropdown != "" ? (
              <Autocomplete
                fullWidth
                size="small"
                key={id}
                disablePortal
                value={(dropdown || []).find((e) => e[label] == value)}
                id={id}
                onChange={(event, newValue) => {
                  changer(newValue[label]);
                }}
                options={dropdown}
                getOptionLabel={(dropdown) =>
                  (dropdown && dropdown[label]) || ""
                }
                getOptionSelected={(option, selectedValue) =>
                  option[label] == selectedValue[label]
                }
                renderInput={(params) => (
                  <TextField
                    key={id}
                    onBlur={formik.handleBlur}
                    error={formik.touched[id] && Boolean(formik.errors[id])}
                    helperText={formik.touched[id] && formik.errors[id]}
                    {...params}
                    fullWidth
                    placeholder={capitalizeFirst(id)}
                  />
                )}
              />
            ) : (
              <TextField
                fullWidth
                id={id}
                multiline={multiline}
                name={id}
                size="small"
                placeholder={placeholder}
                //   label={capitalizeFirst(id)}
                value={value}
                onChange={(e) => {
                  changer(e.target.value);
                }}
                error={formik.touched[id] && Boolean(formik.errors[id])}
                helperText={formik.touched[id] && formik.errors[id]}
              />
            )}
          </Grid>
        </Grid>
      </Grid>
    );
  };

  const label = { inputProps: { "aria-label": "Checkbox demo" } };
  let data2 = [
    { id: "contains" },
    { id: "does not contain" },
    { id: "begin with" },
    { id: "end with" },
    { id: "is equal to" },
    { id: "Amount" },
    { id: "Is More Than" },
    { id: "Is Less Than" },
  ];

  function selectvalue(value) {
    let data = [
      { id: "contains" },
      { id: "does not contain" },
      { id: "begin with" },
      { id: " end with" },
      { id: "is equal to" },
    ];
    if (
      value == "Amount" ||
      value == "Time Elapsed" ||
      value == "Transaction Date"
    ) {
      data = [
        { id: "Is More Than" },
        { id: "Is Less Than" },
        { id: "DATEDIFF" },
      ];
    } else if (value == "Transaction") {
      data = [
        { id: "contains" },
        { id: "does not contain" },
        { id: "begin with" },
        { id: " end with" },
        { id: "is equal to" },
      ];
    } else if (
      value == "Location City" ||
      value == "Location" ||
      value == "IP"
    ) {
      data = [{ id: "is" }, { id: "is not" }];
    } else if (
      value == "Incorrect password entered / retries" ||
      value == "Access to unauthorized functions" ||
      value == "different between current date and previous date"
    ) {
      data = [
        { id: "is more than" },
        { id: "is less than" },
        { id: "is equal" },
      ];
    } else if (
      value == "Date & Timestamp for logon" ||
      value == "Date & Timestamp for logoff"
    ) {
      data = [
        { id: "is between" },
        { id: "is equal to" },
        { id: "is not equal to" },
      ];
    }

    return data;
  }
  function selectvalue2(value) {
    let data = [{ id: "12 Hours" }, { id: "24 Hours" }, { id: "42 Hours" }];

    let data3 = [{ id: "Is More Than" }, { id: "Is Less Than" }];
    let data4 = [{ id: "is" }, { id: "is not" }];

    if (data3.some((item) => value === item.id)) {
      data = data;
    }
    if (data4.some((item) => value === item.id)) {
      data = [
        { id: "matched" },
        { id: "unmatched" },
        { id: "office" },
        { id: "remotely" },
      ];
    }

    return data;
  }

  const TextfieldCustom3 = ({
    id = "",
    size = xs,
    tittle = "",
    placeholder = "",
    dropdown = [],
    label = "",
    multiline = false,
    date = false,
    onChange,
    indexdata = 0,
    namedata = "",
  }) => {
    return (
      <Grid item md={size}>
        <Grid container direction={"column"} spacing={0}>
          <Grid item>
            <Typography variant="subtitle2">{tittle}</Typography>
          </Grid>
          <Grid item>
            {date ? (
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <TimePicker
                  // label="Controlled picker"
                  value={rule[indexdata][namedata]}
                  onChange={(e) => {
                    handleIncrementClick(indexdata, namedata, e);
                  }}
                  renderInput={(params) => (
                    <TextField size="small" fullWidth {...params} />
                  )}
                />
              </LocalizationProvider>
            ) : dropdown != "" ? (
              <Autocomplete
                fullWidth
                size="small"
                disablePortal
                value={(dropdown || []).find(
                  (e) => e[label] == rule[indexdata][namedata]
                )}
                id={id}
                onChange={(event, newValue) => {
                  handleIncrementClick(indexdata, namedata, newValue[label]);
                }}
                // onChange={(event,new) => {
                //   console.log("ppopopo");
                //   console.log(e && e["id"]);
                //   // handleIncrementClick(indexdata, namedata, item.value);
                // }}
                options={dropdown}
                getOptionLabel={(dropdown) =>
                  (dropdown && dropdown[label]) || ""
                }
                getOptionSelected={(option, selectedValue) =>
                  option[label] === selectedValue[label]
                }
                renderInput={(params) => (
                  <TextField
                    multiline
                    onBlur={formik.handleBlur}
                    error={formik.touched[id] && Boolean(formik.errors[id])}
                    helperText={formik.touched[id] && formik.errors[id]}
                    {...params}
                    fullWidth
                    placeholder={capitalizeFirst(id)}
                  />
                )}
              />
            ) : (
              <TextField
                fullWidth
                id={id}
                multiline={multiline}
                name={id}
                size="small"
                placeholder={placeholder}
                value={rule[indexdata][namedata]}
                onChange={(e) => {
                  handleIncrementClick(indexdata, namedata, e.target.value);
                }}
                error={formik.touched[id] && Boolean(formik.errors[id])}
                helperText={formik.touched[id] && formik.errors[id]}
              />
            )}
          </Grid>
        </Grid>
      </Grid>
    );
  };

  function handleIncrementClick(index, value, e) {
    // console.log("awdawd");
    // console.log(value);
    // console.log(e);
    const nextCounters = rule.map((c, i) => {
      if (i == index) {
        // Increment the clicked counter
        return { ...c, [value]: e };
      } else {
        // The rest haven't changed
        return c;
      }
    });
    setRule(nextCounters);
    // console.log(rule);
  }

  

  return (
    <>
      <Helmet>
        <title> Add Rule | SmartShield </title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Add Rule
          </Typography>
        </Stack>
        <Grid container direction={"row"} spacing={3}>
        {TextfieldCustom2({
              id: "rule_name",
              size: 6,
              titles: "Rules Name",
              placeholder: "Rules Name",
              value: rulesname,
              changer: setRulesname,
            })}
            {TextfieldCustom2({
              id: "severity_level",
              size: 6,
              titles: "Severity Level",
              placeholder: "level 1",
              dropdown: [
                { id: "Level 1" },
                { id: "Level 2" },
                { id: "Level 3" },
              ],
              label: "id",
              value: severitylevel,
              changer: setSeveritylevel,
            })}
            {TextfieldCustom2({
              id: "description",
              size: 4,
              titles: "Descriptions",
              placeholder: "Write a rule Description",
              multiline: true,
              value: description,
              changer: setDescription,
            })}
            {TextfieldCustom2({
              id: "status",
              size: 2,
              titles: "Status",
              dropdown: [{ id: "Active" }, { id: "inActive" }],
              label: "id",
              value: status,
              changer: setStatus,
            })}
            {TextfieldCustom2({
              id: "channel",
              size: 2,
              titles: "Channel",
              dropdown: [
                { id: "ATM" },
                { id: "EDC" },
                { id: "INTERNET BANKING" },
                { id: "BRANCH TELLER" },
                { id: "MOBILE BANKING" },
                { id: "SYSTEM ACCESS" },
                { id: "ALL CHANNEL" },
              ],
              label: "id",
              value: channel,
              changer: setChannel,
            })}
            {TextfieldCustom2({
              id: "limit",
              size: 2,
              titles: "Limit to",
              dropdown: [
                { id: "1" },
                { id: "2" },
                { id: "4" },
                { id: "5" },
                { id: "6" },
                { id: "7" },
                { id: "8" },
                { id: "9" },
                { id: "10" },
                { id: "11" },
                { id: "ALL" },
              ],
              label: "id",
              value: limit,
              changer: setLimit,
            })}
            
            <Grid item style={{ alignSelf: "flex-end" }}>
              <Button
                variant="contained"
                endIcon={<AddIcon />}
                style={{
                  textTransform: "none",

                  backgroundColor: "#469A45",
                }}
                onClick={() => {
                  // rule.push({
                  //   id: rule.length,
                  // });
                  const insertAt = 1; // Could be any index
                  const nextArtists = [
                    // Items before the insertion point:
                    ...rule.slice(0, insertAt),
                    // New item:
                    {
                      id: rule.length,
                      if: "",
                      select_operator: "",
                      value: "",
                      parameter: "",
                      condition: "",
                      type: "",
                      select_operator2: "",
                    },
                    // Items after the insertion point:
                    ...rule.slice(insertAt),
                  ];
                  setRule(nextArtists);
                }}
              >
                Add Condition
              </Button>
            </Grid>
         </Grid>
         {channel == "SYSTEM ACCESS"
              ? rule.map((item, i) => (
                  <Grid item xs={12}>
                      <Grid xs={12} container direction={"column"} spacing={1}>
                        <Grid item container direction={"row"}>
                          {" "}
                          <Grid item xs>
                            {" "}
                            {item.id == 0
                              ? ""
                              : TextfieldCustom3({
                                  id: "AND",
                                  size: 2,
                                  tittle: "",
                                  dropdown: [{ id: "AND" }, { id: "OR" }],
                                  label: "id",
                                  indexdata: item.id,
                                  namedata: "condition",
                                })}
                          </Grid>
                          <Grid item>
                            {item.id == 0 ? (
                              ""
                            ) : (
                              <Button
                                key={item.id}
                                variant="contained"
                                style={{
                                  textTransform: "none",
                                  backgroundColor: "red",
                                }}
                                onClick={() => {
                                  // console.log(item.id);
                                  setRule(
                                    rule.filter((a) => {
                                      return a.id !== item.id;
                                    })
                                  );
                                }}
                              >
                                Delete Condition
                              </Button>
                            )}
                          </Grid>
                        </Grid>
                        <Grid item container direction={"row"} spacing={2}>
                          {" "}
                          {TextfieldCustom3({
                            id: "ANY",
                            size: 4,
                            tittle: "Where",
                            dropdown: [
                              { id: "Account Status" },
                              { id: "Date" },
                              { id: "User ID" },
                              { id: "Date & Timestamp for logon" },
                              { id: "Date & Timestamp for logoff" },
                              { id: "Location" },
                              { id: "IP" },
                              { id: "Incorrect password entered / retries" },
                              { id: "Functions accessed" },
                              {
                                id: "Access to unauthorized functions",
                              },
                            ],
                            label: "id",
                            indexdata: item.id,
                            namedata: "if",
                          })}
                          {rule[item.id]["if"] == "" ||
                          rule[item.id]["if"] != "ANY"
                            ? ""
                            : TextfieldCustom3({
                                id: "AND",
                                size: 2,
                                tittle: "Parameter",
                                dropdown: [
                                  { id: "Time Elapsed" },
                                  { id: "Entry" },
                                  { id: "Location" },
                                  { id: "Amount" },
                                  { id: "Transaction" },
                                  { id: "ANY" },
                                ],
                                label: "id",
                                indexdata: item.id,
                                namedata: "parameter",
                              })}
                          {(rule[item.id]["parameter"] == "" &&
                            rule[item.id]["if"] == "ANY") ||
                          rule[item.id]["if"] == ""
                            ? ""
                            : rule[item.id]["if"] == "DATEDIFF"
                            ? ""
                            : TextfieldCustom3({
                                id: "AND",
                                size: 2,
                                tittle: "Select Operator",
                                dropdown: selectvalue(
                                  rule[item.id]["if"] == "ANY"
                                    ? rule[item.id]["parameter"]
                                    : rule[item.id]["if"]
                                ),
                                label: "id",
                                indexdata: item.id,
                                namedata: "select_operator",
                              })}
                          {rule[item.id]["select_operator"] == "" ? (
                            ""
                          ) : data2.some(
                              (items) =>
                                items.id === rule[item.id]?.["select_operator"]
                            ) && rule[item.id]["if"] != "Time Elapsed" ? (
                            rule[item.id]?.["if"] == "Account Status" ? (
                              TextfieldCustom3({
                                id: "Active",
                                size: 2,
                                tittle: "Value",
                                dropdown: [
                                  { id: "Active" },
                                  { id: "Inactive" },
                                  { id: "Doormant" },
                                  { id: "Closed" },
                                ],
                                label: "id",
                                indexdata: item.id,
                                namedata: "value",
                              })
                            ) : (
                              TextfieldCustom3({
                                id: "type",
                                size: 2,
                                tittle: "Value",
                                dropdown:
                                  rule[item.id]?.["select_operator"] ==
                                  "is equal to"
                                    ? rule[item.id]?.["if"] == "Date"
                                      ? [{ id: "Bank Holiday" }]
                                      : [{ id: "Card system" }]
                                    : [],
                                label: "id",
                                indexdata: item.id,
                                namedata: "value",
                              })
                            )
                          ) : rule[item.id]["select_operator"] == "DATEDIFF" ? (
                            TextfieldCustom3({
                              id: "AND",
                              size: 2,
                              tittle: "Select Second Operator",
                              dropdown: [
                                { id: "is more than" },
                                { id: "is less than" },
                              ],
                              label: "id",
                              indexdata: item.id,
                              namedata: "select_operator2",
                            })
                          ) : rule[item.id]["select_operator"] ==
                            "is between" ? (
                            <>
                              {TextfieldCustom3({
                                id: "AND",
                                size: 2,
                                tittle: "Start Time",
                                dropdown: selectvalue2(
                                  rule[item.id]["select_operator"]
                                ),
                                date: true,
                                label: "id",
                                indexdata: item.id,
                                namedata: "value",
                              })}
                              {TextfieldCustom3({
                                id: "AND",
                                size: 2,
                                date: true,
                                tittle: "End Time",
                                dropdown: selectvalue2(
                                  rule[item.id]["select_operator"]
                                ),
                                label: "id",
                                indexdata: item.id,
                                namedata: "type",
                              })}
                            </>
                          ) : (
                            TextfieldCustom3({
                              id: "AND",
                              size: 2,
                              tittle: "Value",
                              dropdown:
                                rule[item.id]["if"] ==
                                  "Incorrect password entered / retries" ||
                                rule[item.id]["if"] ==
                                  "Access to unauthorized functions"
                                  ? [
                                      { id: "0" },
                                      { id: "1" },
                                      { id: "2" },
                                      { id: "3" },
                                    ]
                                  : selectvalue2(
                                      rule[item.id]["select_operator"]
                                    ),
                              label: "id",
                              indexdata: item.id,
                              namedata: "value",
                            })
                          )}
                          {rule[item.id]["select_operator2"] == "" ? (
                            ""
                          ) : (
                            <>
                              {TextfieldCustom3({
                                id: "1",
                                size: 1,
                                tittle: "Value",
                                dropdown: [
                                  { id: "1" },
                                  { id: "2" },
                                  { id: "3" },
                                  { id: "4" },
                                  { id: "5" },
                                ],
                                label: "id",
                                indexdata: item.id,
                                namedata: "value",
                              })}
                              <span style={{ width: 20 }}></span>
                              {TextfieldCustom3({
                                id: "Month",
                                size: 2,
                                tittle: "Date",
                                dropdown: [
                                  { id: "Hours" },
                                  { id: "Months" },
                                  { id: "Years" },
                                ],
                                label: "id",
                                indexdata: item.id,
                                namedata: "type",
                              })}
                            </>
                          )}
                        </Grid>
                      </Grid>
                  </Grid>
                ))
              : rule.map((item, i) => (
                  <Grid item xs={12}>
                      <Grid xs={12} container direction={"column"} spacing={1}>
                        <Grid item container direction={"row"}>
                          {" "}
                          <Grid item xs>
                            {" "}
                            {item.id == 0
                              ? ""
                              : TextfieldCustom3({
                                  id: "AND",
                                  size: 2,
                                  tittle: "",
                                  dropdown: [{ id: "AND" }, { id: "OR" }],
                                  label: "id",
                                  indexdata: item.id,
                                  namedata: "condition",
                                })}
                          </Grid>
                          <Grid item>
                            {item.id == 0 ? (
                              ""
                            ) : (
                              <Button
                                key={item.id}
                                variant="contained"
                                style={{
                                  textTransform: "none",
                                  backgroundColor: "red",
                                }}
                                onClick={() => {
                                  // console.log(item.id);
                                  setRule(
                                    rule.filter((a) => {
                                      return a.id !== item.id;
                                    })
                                  );
                                }}
                              >
                                Delete Condition
                              </Button>
                            )}
                          </Grid>
                        </Grid>
                        <Grid item container direction={"row"} spacing={2}>
                          {" "}
                          {TextfieldCustom3({
                            id: "ANY",
                            size: 3,
                            tittle: "Where",
                            dropdown: [
                              { id: "Transaction Date" },
                              {
                                id: "different between current date and previous date",
                              },
                              { id: "Time Elapsed" },
                              { id: "Entry" },
                              { id: "Location City" },
                              { id: "Amount" },
                              { id: "Transaction" },
                              { id: "ANY" },
                            ],
                            label: "id",
                            indexdata: item.id,
                            namedata: "if",
                          })}
                          {rule[item.id]["if"] == "" ||
                          rule[item.id]["if"] != "ANY"
                            ? ""
                            : TextfieldCustom3({
                                id: "AND",
                                size: 2,
                                tittle: "Parameter",
                                dropdown: [
                                  { id: "Time Elapsed" },
                                  { id: "Entry" },
                                  { id: "Location City" },
                                  { id: "Amount" },
                                  { id: "Transaction" },
                                  { id: "ANY" },
                                ],
                                label: "id",
                                indexdata: item.id,
                                namedata: "parameter",
                              })}
                          {(rule[item.id]["parameter"] == "" &&
                            rule[item.id]["if"] == "ANY") ||
                          rule[item.id]["if"] == ""
                            ? ""
                            : rule[item.id]["if"] == "DATEDIFF"
                            ? ""
                            : TextfieldCustom3({
                                id: "AND",
                                size: 2,
                                tittle: "Select Operator",
                                dropdown: selectvalue(
                                  rule[item.id]["if"] == "ANY"
                                    ? rule[item.id]["parameter"]
                                    : rule[item.id]["if"]
                                ),
                                label: "id",
                                indexdata: item.id,
                                namedata: "select_operator",
                              })}
                          {rule[item.id]["select_operator"] == ""
                            ? ""
                            : data2.some(
                                (items) =>
                                  items.id ===
                                  rule[item.id]?.["select_operator"]
                              ) && rule[item.id]["if"] != "Time Elapsed"
                            ? TextfieldCustom3({
                                id: "AND",
                                size: 2,
                                tittle: "Value",
                                label: "id",
                                indexdata: item.id,
                                namedata: "value",
                              })
                            : rule[item.id]["select_operator"] == "DATEDIFF"
                            ? TextfieldCustom3({
                                id: "AND",
                                size: 2,
                                tittle: "Select Second Operator",
                                dropdown: [
                                  { id: "is more than" },
                                  { id: "is less than" },
                                ],
                                label: "id",
                                indexdata: item.id,
                                namedata: "select_operator2",
                              })
                            : TextfieldCustom3({
                                id: "AND",
                                size: 2,
                                tittle: "Value",
                                dropdown:
                                  rule[item.id]["if"] ==
                                  "different between current date and previous date"
                                    ? [
                                        { id: "1 Months" },
                                        { id: "2 Months" },
                                        { id: "3 Months" },
                                        { id: "4 Months" },
                                      ]
                                    : selectvalue2(
                                        rule[item.id]["select_operator"]
                                      ),
                                label: "id",
                                indexdata: item.id,
                                namedata: "value",
                              })}
                          {rule[item.id]["select_operator2"] == "" ? (
                            ""
                          ) : (
                            <>
                              {TextfieldCustom3({
                                id: "1",
                                size: 1,
                                tittle: "Value",
                                dropdown: [
                                  { id: "1" },
                                  { id: "2" },
                                  { id: "3" },
                                  { id: "4" },
                                  { id: "5" },
                                ],
                                label: "id",
                                indexdata: item.id,
                                namedata: "value",
                              })}
                              <span style={{ width: 20 }}></span>
                              {TextfieldCustom3({
                                id: "Month",
                                size: 2,
                                tittle: "Date",
                                dropdown: [
                                  { id: "Hours" },
                                  { id: "Month" },
                                  { id: "Years" },
                                ],
                                label: "id",
                                indexdata: item.id,
                                namedata: "type",
                              })}
                            </>
                          )}
                        </Grid>
                      </Grid> 
                  </Grid>
                ))}
                
                <Grid item xs={12} style={{ textAlignLast: "right" }}>
                          {rule.length >= 1 ? (
                            <Button
                              variant="contained"
                              endIcon={<AddIcon />}
                              style={{
                                textTransform: "none",
                                backgroundColor: "#679DA0",
                              }}
                              onClick={save}
                            >
                              Generate Rule
                            </Button>
                          ) : (
                            ""
                          )}
                        </Grid>
      </Container>
    </>
    
  );
}
